import React, { useState } from 'react';
import { useAuthContext } from '../../contexts/Auth';
import { useOnboardingContext } from '../../contexts/Onboarding';
import { useEventTrackerContext } from '../../contexts/EventTracker';
import { useHistory } from 'react-router';
import { login, errorHandler } from '../../utils';
import { Auth } from 'aws-amplify';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Layout from '../../components/auth/Layout';
import SignIn from '../../components/auth/SignIn';
import VerifyEmail from '../../components/auth/VerifyEmail';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 70,
  },
}));

export default function Login() {
  const classes = useStyles();
  const history = useHistory();
  const { trackEvent } = useEventTrackerContext();
  const { signIn, setUser } = useAuthContext();
  const { setHasCompletedOnboarding, setActiveStep } = useOnboardingContext();
  const [error, setError] = useState(null);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [emailVerificationRequired, setEmailVerificationRequired] =
    useState(false);

  return (
    <div className={classes.root}>
      <Layout title={emailVerificationRequired ? '' : 'Sign In'}>
        {emailVerificationRequired && (
          <div>
            <VerifyEmail email={email} password={password} />
          </div>
        )}
        {!emailVerificationRequired && (
          <SignIn
            {...{ error }}
            onSubmit={async (email, password) => {
              try {
                setEmail(email);
                setPassword(password);
                await login({
                  email,
                  password,
                  signIn,
                  history,
                  setUser,
                  setHasCompletedOnboarding,
                  setActiveStep,
                });
                trackEvent({ event: 'login', user: email });
              } catch (error) {
                if (error.name === 'UserNotConfirmedException') {
                  await Auth.resendSignUp(email);
                  return setEmailVerificationRequired(true);
                } else {
                  errorHandler(error);
                  setError(error.message);
                }
              }
            }}
          />
        )}
      </Layout>
    </div>
  );
}
